<app-header></app-header>

<div class="conversion-container">
  <div class="conversion-content">
    <!-- Icône de conversion -->
    <div class="conversion-icon">
      <i class="bi bi-file-earmark-pdf-fill"></i>
    </div>
    
    <!-- Titre et numéro de téléphone -->
    <h2 class="conversion-title">Conversion en cours ...</h2>
    
    <!-- Carte d'informations -->
    <div class="info-card mt-5">
      <div class="info-row">
        <span class="info-label">Fichier :</span>
        <span class="info-value">{{ filename }}</span>
      </div>
      <div class="info-row">
        <span class="info-label">Taille :</span>
        <span class="info-value">{{ size.toFixed(2) }} Mo</span>
      </div>
    </div>
    
    <!-- Barre de progression -->
    <div class="progress-section">
      <div class="progress-label">Progression</div>
      <div class="progress-bar-container">
        <div class="progress-bar">
          <div class="progress-bar-fill" [style.width.%]="progress"></div>
        </div>
        <div class="progress-text">{{ progress }}%</div>
      </div>
    </div>
    
    <!-- Messages de statut -->
    <div class="status-messages">
      <div class="completion-message" *ngIf="isCompleted">
        <i class="bi bi-check-circle-fill"></i>
        <span>Conversion terminée !</span>
      </div>
      <div class="redirect-message" *ngIf="isRedirecting">
        Redirection en cours...
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>